import { getTempToken } from "@/api/login";
import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
import {fieldsInquiry} from "@/api/inquiry";
Vue.use(Vuex);
//向旭扩展
export default new Vuex.Store({
  //变量data
  state: {
    // isLogin: account.isLogin,
    token: "",
    userInfo: {},// store和cookie里面存储了userInfo
    siteInfo: {},// store和cookie里面存储了站点信息
    test: 0,
    site_id: "1", //中文为1，英文为0 siteInfo包含了这些信息
    tabs: [],
    productTabs: [],
    carNum: false, //购物车是否变化
    inquiryNum: false, //产品咨询是否变化
    compareNum: false, //对比产品是否变化
    compareList: [],
    routeHistory: []
    // userInfo:account.userInfo
  },
  //相似于计算属性computed
  getters: {
    getUserInfo(state) {
      return state.userInfo;
    }
  },
  //方法methods
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USERINFO(state, userinfo) {
      state.userInfo = userinfo;
    },
    SET_SITEINFO(state, siteinfo) {
      state.siteInfo = siteinfo;
    },
    SET_TABS(state, tabs) {
      state.tabs = tabs;
    },
    SET_CARNUM(state, flag) {
      state.carNum = flag;
    },
    SET_CARLIST(state, flag) {
      state.carList = flag;
    },
    SET_INQUIRYNUM(state, flag) {
      state.inquiryNum = flag;
    },
    SET_INQUIRYLIST(state, flag) {
      state.inquiryList = flag;
    },
    SET_COMPARENUM(state, flag) {
      state.compareNum = flag;
    },
    SET_COMPARELIST(state, list) {
      state.compareList = list;
    },
    updateRouteHistory(state, route) {
      state.routeHistory.push(route);
    }
  },
  //异步操做
  actions: {
    getwhUUid({ commit }) {
      return new Promise((resolve, reject) => {
        var body = {};
        getTempToken({})
          .then((res) => {
            if (res) {
              // debugger;
        // "uuid": "0A06A26F-AD01-5B69-576E-50A57F9490D3",
        // setToken(res.data.token);  
              commit("SET_TOKEN", res.data.token);
              localStorage.setItem("WuhanWebUUID",res.data.uuid);
              // Cookies.set("WuhanWebUUID","0A06A26F-AD01-5B69-576E-50A57F9490D3");
              Cookies.set("WuhanToken", res.data.token);
              Cookies.set("WHTimestamp", Date.parse(new Date()) / 1000 - res.data.timestamp);
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });

    },//登录成功后设置用户的信息

    setUserinfo(context, userinfo) {
      context.commit("SET_USERINFO", userinfo);
      Cookies.set("userinfo", JSON.stringify(userinfo));
    },

    setSiteInfo(context, siteinfo) {
      //设置站点信息
      context.commit("SET_SITEINFO", siteinfo);
      //存入cookies
      Cookies.set("siteInfo", siteinfo);
    },

    setTabs(context, tabs) {
      context.commit("SET_TABS", tabs);
    },
    setCarNum(context, flag) {
      context.commit("SET_CARNUM", flag);
    },
    setCarList(context, flag) {
      context.commit("SET_CARLIST", flag);
    },
    setInquiryNum(context, flag) {
      context.commit("SET_INQUIRYNUM", flag);
    },
    setInquiryList(context, flag) {
      context.commit("SET_INQUIRYLIST", flag);
    },
    setCompareNum(context, flag) {
      context.commit("SET_COMPARENUM", flag);
    },
    setCompareList(context, list) {
      context.commit("SET_COMPARELIST", list);
    }
  },
  //模块
  modules: {}
});


{/* <p>{{$store.state.isLogin}}</p> */
}
